// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import { useCheckedStateSecondary } from '../../../../shared/contexts/Secondary/CheckedContextSecondary'
import config from '../../../../config/config'

// Function based component that renders a clear all label
function ClearAllSecondary({ data }) {
  const { checkedState, setCheckedState } = useCheckedStateSecondary()

  // Handler that removes all selected data points
  const removeAllSelected = () => {
    let updatedCheckedState = JSON.parse(JSON.stringify(checkedState))
    for (let element of data) {
      updatedCheckedState[element[config.data.secondary_primary_key]] = false
    }
    setCheckedState(updatedCheckedState)
  }

  return (
    <button
      className="med-clear-all-button med-primary-text"
      onClick={removeAllSelected}
      data-testid="clear-all-label"
    >
      Clear All <i className="bx bxs-trash"></i>
    </button>
  )
}

export default ClearAllSecondary
